import { createContext, useState, useEffect } from "react";
import ApiService, { setCSRFToken } from "../services/api";

export const AuthContext = createContext(null);

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on mount
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const response = await ApiService.getCurrentUser();
        
        if (response.csrf_token) {
          setCSRFToken(response.csrf_token);
        }

        if (response.authenticated && response.user) {
          setUser({
            name: `${response.user.first_name} ${response.user.last_name}`.trim() || response.user.username,
            email: response.user.email || '',
            phone: response.user.username,
            first_name: response.user.first_name,
            last_name: response.user.last_name,
            role: response.user.role || 'customer',
            role_id: response.user.role_id || null,
            role_name: response.user.role_name || null,
          });
          setIsLoggedIn(true);
        } else {
          setUser(null);
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        setUser(null);
        setIsLoggedIn(false);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const login = (userData) => {
    setUser({
      name: `${userData.first_name} ${userData.last_name}`.trim() || userData.username,
      email: userData.email || '',
      phone: userData.username,
      first_name: userData.first_name,
      last_name: userData.last_name,
      role: userData.role || 'customer',
      role_id: userData.role_id || null,
      role_name: userData.role_name || null,
    });
    setIsLoggedIn(true);
  };

  const logout = async () => {
    try {
      await ApiService.logout();
      setUser(null);
      setIsLoggedIn(false);
      setCSRFToken(null);
      return { success: true };
    } catch (error) {
      console.error('Logout failed:', error);
      setUser(null);
      setIsLoggedIn(false);
      setCSRFToken(null);
      return { success: false, error };
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoggedIn,
        loading,
        setUser,
        setIsLoggedIn,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
